module.exports = __webpack_public_path__ + "static/img/early-settlement-payment-amount.2bdb85e0.svg";